export class FooterTextDataES {
    static readonly htmlLabel = {
        privacyPolicy: 'Política de Privacidad',
        poweredBy: 'Desarrollado por Continual Engine',
    };
    static readonly snackbarLabels = {

    };
    static readonly tooltipLabels = {

    }
}